<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content><p class="mat-body-1">{{message}}</p></mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="{{cancelColor}}"  (click)="cancel()">{{cancelLabel}}</button>
  <button mat-raised-button color="{{confirmColor}}" (click)="confirm()">{{confirmLabel}}</button>
</mat-dialog-actions>
